// extracted by mini-css-extract-plugin
export default {"productGallery":"zO-z","inQuickShop":"AO-z"};